module.exports = __webpack_public_path__ + "img/83.fb8e1068.jpg";